import { Link, Typography } from "@mui/material";
import { useTenant } from "hooks/useTenant";
import { Link as RouterLink } from "react-router-dom";
import { NO_VALUE } from "routes/Customer/Waste/Invoices/utils";

import { ExceptionRow } from "./columns";

/**
 * The invoices a result was drawn from, each opening the invoice it names —
 * the number a reader quotes back to the vendor, and the page they open to
 * check it. A result with no billing behind it has none to show.
 */
export function InvoiceLinks({ visit }: { visit: ExceptionRow["visit"] }) {
  const { tenantId } = useTenant();
  const numbers = visit?.invoiceNumbers ?? [];
  if (numbers.length === 0 || !tenantId) return <>{NO_VALUE}</>;

  return (
    <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
      {numbers.map((number, index) => (
        <span key={number}>
          {index > 0 ? ", " : ""}
          <Link
            component={RouterLink}
            to={`/o/${tenantId}/waste/invoices/${visit?.invoiceIds[index] ?? ""}`}
            onClick={(event) => event.stopPropagation()}
          >
            {number}
          </Link>
        </span>
      ))}
    </Typography>
  );
}
